import React from "react"
import {
  FaReact,
  FaCss3,
  FaSass,
  FaNodeJs,
  FaGithub,
  FaHtml5,
  FaNpm,
  FaLinux,
} from "react-icons/fa"
import { RiGatsbyFill } from "react-icons/ri"
import { GrGraphQl } from "react-icons/gr"
import { BiCloudUpload } from "react-icons/bi"
import {
  SiMongodb,
  SiJavascript,
  SiNetlify,
  SiFirebase,
  SiHeroku,
  SiStrapi,
  SiStyledComponents,
  SiBabel,
  SiWebpack,
  SiPostgresql,
} from "react-icons/si"

const Technology = [
  {
    name: "react",
    icons: <FaReact style={{ color: "#5EC7F1" }} />,
    color: "#5EC7F1",
  },
  {
    name: "gatsby",
    icons: <RiGatsbyFill style={{ color: "#644094" }} />,
    color: "#644094",
  },
  {
    name: "graphql",
    icons: <GrGraphQl style={{ color: "#DF59A5" }} />,
    color: "#DF59A5",
  },
  {
    name: "Html5",
    icons: <FaHtml5 style={{ color: "#DC4C25" }} />,
    color: "#DC4C25",
  },
  {
    name: "css",
    icons: <FaCss3 style={{ color: "#0574B7" }} />,
    color: "#0574B7",
  },
  {
    name: "Scss",
    icons: <FaSass style={{ color: "#C66395" }} />,
    color: "#C66395",
  },
  {
    name: "Styled components",
    icons: <SiStyledComponents style={{ color: "#F7C336" }} />,
    color: "#C66395",
  },
  {
    name: "Node",
    icons: <FaNodeJs style={{ color: "#74B141" }} />,
    color: "#74B141",
  },
  {
    name: "Npm",
    icons: <FaNpm style={{ color: "#C7361B" }} />,
    color: "#74B141",
  },
  {
    name: "Babel",
    icons: <SiBabel style={{ color: "#EDD75B" }} />,
    color: "#74B141",
  },
  {
    name: "Webpack",
    icons: <SiWebpack style={{ color: "#1C75BA" }} />,
    color: "#74B141",
  },
  {
    name: "Linux",
    icons: <FaLinux style={{ color: "#575757" }} />,
    color: "#74B141",
  },
  {
    name: "Github",
    icons: <FaGithub style={{ color: "#0574B7" }} />,
    color: "#F7F7F7",
  },
  {
    name: "Mongoose",
    icons: <SiMongodb style={{ color: "#469639" }} />,
    color: "#F7F7F7",
  },
  {
    name: "Postgresql",
    icons: <SiPostgresql style={{ color: "#32648C" }} />,
    color: "#F7F7F7",
  },
  {
    name: "Javascript",
    icons: <SiJavascript style={{ color: "#EADA36" }} />,
    color: "#EADA36",
  },
  {
    name: "Cloudinary",
    icons: <BiCloudUpload style={{ color: "#0574B7" }} />,
    color: "#fff",
  },
  {
    name: "Firebase",
    icons: <SiFirebase style={{ color: "#FFCD36" }} />,
    color: "#FFCD36",
  },
  {
    name: "Netlify",
    icons: <SiNetlify style={{ color: "#0574B7" }} />,
    color: "#fff",
  },
  {
    name: "Strapi,",
    icons: <SiStrapi style={{ color: "#0574B7" }} />,
    color: "#fff",
  },
  {
    name: "Heroku",
    icons: <SiHeroku style={{ color: "#0574B7" }} />,
    color: "#fff",
  },
]

export default Technology
